"use client";

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Card } from '@/components/ui/Card';
import { Code, Palette, Database, Smartphone, LineChart, Globe, BookOpen, Star } from 'lucide-react';
export default function Courses() {
  const $ = _c(27);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 0.2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref,
    isVisible
  } = useScrollAnimation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      icon: Code,
      title: "Web Development",
      description: "Master HTML, CSS, JavaScript, React, and Node.js",
      students: "12,450",
      rating: 4.8,
      price: "Free",
      color: "from-blue-500 to-cyan-500"
    }, {
      icon: Smartphone,
      title: "Mobile App Development",
      description: "Build iOS and Android apps with React Native & Flutter",
      students: "8,320",
      rating: 4.9,
      price: "$49",
      color: "from-purple-500 to-pink-500"
    }, {
      icon: Database,
      title: "Data Science & AI",
      description: "Python, Machine Learning, Data Analysis & Visualization",
      students: "15,670",
      rating: 4.7,
      price: "$79",
      color: "from-green-500 to-emerald-500"
    }, {
      icon: Palette,
      title: "UI/UX Design",
      description: "Design beautiful interfaces with Figma & Adobe XD",
      students: "9,890",
      rating: 4.8,
      price: "Free",
      color: "from-pink-500 to-rose-500"
    }, {
      icon: LineChart,
      title: "Digital Marketing",
      description: "SEO, Social Media, Content Marketing & Analytics",
      students: "11,230",
      rating: 4.6,
      price: "$39",
      color: "from-orange-500 to-red-500"
    }, {
      icon: Globe,
      title: "Cloud Computing",
      description: "AWS, Azure, Docker, Kubernetes & DevOps",
      students: "7,560",
      rating: 4.9,
      price: "$89",
      color: "from-indigo-500 to-blue-500"
    }];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const courses = t1;
  const t2 = ref as React.RefObject<HTMLElement>;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 20
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isVisible) {
    t4 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[3] = isVisible;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      duration: 0.6
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-semibold mb-4"><BookOpen className="w-4 h-4" /><span>1000+ Premium Courses</span></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Learn Skills That<span className="block bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">Companies Need</span></h2>;
    t8 = <p className="text-xl text-gray-600 max-w-3xl mx-auto">Start with free courses or unlock everything with premium access</p>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4) {
    t9 = <motion.div initial={t3} animate={t4} transition={t5} className="text-center mb-16">{t6}{t7}{t8}</motion.div>;
    $[9] = t4;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== isVisible) {
    t10 = <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">{courses.map((course, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: index * 0.1
      }}><Card hover={true} className="h-full group cursor-pointer"><div className="p-6"><div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${course.color} flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform`}><course.icon className="w-8 h-8 text-white" /></div><h3 className="text-xl font-bold text-gray-900 mb-2">{course.title}</h3><p className="text-gray-600 mb-4">{course.description}</p><div className="flex items-center justify-between pt-4 border-t border-gray-200"><div className="flex items-center gap-1"><Star className="w-4 h-4 fill-yellow-400 text-yellow-400" /><span className="text-sm font-semibold text-gray-900">{course.rating}</span></div><div className="text-sm text-gray-600">{course.students} students</div></div><div className="mt-4 flex items-center justify-between"><span className="text-2xl font-bold text-[#6059f7]">{course.price}</span><button className="px-4 py-2 bg-[#6059f7] text-white rounded-lg font-semibold hover:bg-[#6059f7]/90 transition-colors">Enroll Now</button></div></div></Card></motion.div>)}</div>;
    $[11] = isVisible;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      opacity: 0,
      y: 20
    };
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== isVisible) {
    t12 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[14] = isVisible;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      duration: 0.6,
      delay: 0.8
    };
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg hover:shadow-xl">View All Courses</button>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t12) {
    t15 = <motion.div initial={t11} animate={t12} transition={t13} className="mt-12 text-center">{t14}</motion.div>;
    $[18] = t12;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t10 || $[21] !== t15 || $[22] !== t9) {
    t16 = <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t9}{t10}{t15}</div>;
    $[20] = t10;
    $[21] = t15;
    $[22] = t9;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t16 || $[25] !== t2) {
    t17 = <section id="courses" className="py-20 md:py-32 bg-gradient-to-br from-gray-50 to-blue-50" ref={t2}>{t16}</section>;
    $[24] = t16;
    $[25] = t2;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  return t17;
}